module.exports = __webpack_public_path__ + "img/18.942bdb1f.png";